import React, {useCallback, useEffect, useId, useMemo, useRef, useState} from 'react'
import {
    siYoutube, siFigma, siNotion, siGithub, siGoogledocs, siGoogledrive,
    siGooglesheets, siGoogleslides, siTelegram, siLoom, siMiro, siVimeo,
    siDropbox, siConfluence, siLinear, siJira, siTrello,
} from 'simple-icons'
import styles from './index.module.scss'
import SendIcon from "../../../../../../assets/icon/SendIcon"
import Avatar from "../../../../../Avatar"
import UserService from "../../../../../../services/user.service"
import {
    COMMENT_LENGTH_WARNING,
    COMMENT_MAX_LENGTH,
    getCommentCharacterCount,
    isCommentTooLongError,
    serializeCommentContent,
} from '../../../../../../utils/commentContent'
import { clipboardTableToMarkdown } from '../../../../../../utils/tableClipboard'
import { htmlToCommentMarkdown } from '../../../../../../utils/commentMarkdown'
import { getAttachmentUploadErrorMessage, getAttachmentValidationMessage, MAX_TASK_ATTACHMENTS } from '../../../../../../utils/attachmentValidation'
import { dispatchProjectNotification } from '../../../../../../utils/projectNotification'
import { snapshotFiles } from '../../../../../../utils/clipboardFiles'

const ICON_COLOR = '#282831'

const AttachToolIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.7129 20.5C9.23956 20.5 7.98581 19.9829 6.95164 18.9487C5.91747 17.9146 5.40039 16.6608 5.40039 15.1875V7.325C5.40039 6.2625 5.77241 5.35952 6.51644 4.61605C7.26047 3.87258 8.16346 3.50057 9.22539 3.5C10.2873 3.49943 11.1906 3.87145 11.9352 4.61605C12.6798 5.36065 13.0515 6.26363 13.0504 7.325V12.85C13.0504 13.0908 12.9688 13.2928 12.8056 13.456C12.6424 13.6192 12.4407 13.7006 12.2004 13.7C11.9601 13.6994 11.7584 13.6178 11.5952 13.4552C11.432 13.2926 11.3504 13.0908 11.3504 12.85V7.325C11.3362 6.73 11.1274 6.22708 10.7239 5.81625C10.3205 5.40542 9.82096 5.2 9.22539 5.2C8.62982 5.2 8.12691 5.40542 7.71664 5.81625C7.30637 6.22708 7.10096 6.73 7.10039 7.325V15.1875C7.08622 16.1933 7.43331 17.047 8.14164 17.7485C8.84997 18.4501 9.70706 18.8006 10.7129 18.8C10.9537 18.8 11.1804 18.7751 11.3929 18.7252C11.6054 18.6753 11.8108 18.6153 12.0091 18.545C12.2358 18.46 12.4554 18.4637 12.6679 18.556C12.8804 18.6484 13.0291 18.8076 13.1141 19.0337C13.1991 19.2598 13.1957 19.4794 13.1039 19.6925C13.0121 19.9056 12.8526 20.0543 12.6254 20.1387C12.3279 20.2521 12.0199 20.3408 11.7014 20.4048C11.383 20.4688 11.0535 20.5006 10.7129 20.5ZM15.1754 19.65C14.9346 19.65 14.7328 19.5684 14.5702 19.4052C14.4076 19.242 14.326 19.0403 14.3254 18.8V17.1H12.6254C12.3846 17.1 12.1828 17.0184 12.0202 16.8552C11.8576 16.692 11.776 16.4903 11.7754 16.25C11.7748 16.0097 11.8564 15.808 12.0202 15.6448C12.184 15.4816 12.3857 15.4 12.6254 15.4H14.3254V13.7C14.3254 13.4592 14.407 13.2574 14.5702 13.0948C14.7334 12.9322 14.9351 12.8506 15.1754 12.85C15.4157 12.8494 15.6177 12.931 15.7814 13.0948C15.9452 13.2586 16.0265 13.4603 16.0254 13.7V15.4H17.7254C17.9662 15.4 18.1682 15.4816 18.3314 15.6448C18.4946 15.808 18.576 16.0097 18.5754 16.25C18.5748 16.4903 18.4932 16.6923 18.3306 16.856C18.168 17.0198 17.9662 17.1011 17.7254 17.1H16.0254V18.8C16.0254 19.0408 15.9438 19.2428 15.7806 19.406C15.6174 19.5692 15.4157 19.6506 15.1754 19.65ZM9.22539 16.25C8.98456 16.25 8.78282 16.1684 8.62019 16.0052C8.45756 15.842 8.37596 15.6403 8.37539 15.4V7.75C8.37539 7.50917 8.45699 7.30743 8.62019 7.1448C8.78339 6.98217 8.98512 6.90057 9.22539 6.9C9.46566 6.89943 9.66767 6.98103 9.83144 7.1448C9.99521 7.30857 10.0765 7.5103 10.0754 7.75V15.4C10.0754 15.6408 9.99379 15.8428 9.83059 16.006C9.66739 16.1692 9.46566 16.2506 9.22539 16.25ZM15.1754 11.15C14.9346 11.15 14.7328 11.0684 14.5702 10.9052C14.4076 10.742 14.326 10.5403 14.3254 10.3V7.75C14.3254 7.50917 14.407 7.30743 14.5702 7.1448C14.7334 6.98217 14.9351 6.90057 15.1754 6.9C15.4157 6.89943 15.6177 6.98103 15.7814 7.1448C15.9452 7.30857 16.0265 7.5103 16.0254 7.75V10.3C16.0254 10.5408 15.9438 10.7428 15.7806 10.906C15.6174 11.0692 15.4157 11.1506 15.1754 11.15Z" fill={ICON_COLOR}/>
    </svg>
)

const MentionToolIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C13.5717 20.5 15.0455 20.0739 16.3107 19.3309C16.6679 19.1212 16.7878 18.6617 16.5781 18.3045C16.3684 17.9472 15.9089 17.8273 15.5517 18.037C14.5135 18.6466 13.299 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12V12.75C19 13.4404 18.4404 14 17.75 14C17.0596 14 16.5 13.4404 16.5 12.75V12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C13.2611 16.5 14.4009 15.981 15.218 15.1444C15.7745 15.9667 16.7152 16.5 17.75 16.5C19.4069 16.5 20.5 15.1569 20.5 13.75V12C20.5 7.30558 16.6944 3.5 12 3.5ZM12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z" fill={ICON_COLOR}/>
    </svg>
)

const LinkToolIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.6 12H15.4M9.45 8.5H6.9C5.99826 8.5 5.13346 8.86875 4.49584 9.52513C3.85821 10.1815 3.5 11.0717 3.5 12C3.5 12.9283 3.85821 13.8185 4.49584 14.4749C5.13346 15.1313 5.99826 15.5 6.9 15.5H9.45M14.55 8.5H17.1C18.0017 8.5 18.8665 8.86875 19.5042 9.52513C20.1418 10.1815 20.5 11.0717 20.5 12C20.5 12.9283 20.1418 13.8185 19.5042 14.4749C18.8665 15.1313 18.0017 15.5 17.1 15.5H14.55" stroke={ICON_COLOR} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

const SearchPopupIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.99902 11.2922C4.99902 7.8171 7.81612 5 11.2912 5C14.7662 5 17.5833 7.8171 17.5833 11.2922C17.5833 12.7779 17.0685 14.1431 16.2075 15.2196L16.1635 15.2745L18.8148 17.9259C19.0605 18.1716 19.0605 18.57 18.8148 18.8157C18.5691 19.0614 18.1707 19.0614 17.925 18.8157L15.2736 16.1644L15.2187 16.2084C14.1422 17.0695 12.7769 17.5843 11.2912 17.5843C7.81612 17.5843 4.99902 14.7672 4.99902 11.2922ZM11.2912 6.25843C8.51113 6.25843 6.25746 8.51211 6.25746 11.2922C6.25746 14.0722 8.51113 16.3259 11.2912 16.3259C14.0712 16.3259 16.3249 14.0722 16.3249 11.2922C16.3249 8.51211 14.0712 6.25843 11.2912 6.25843Z" fill="currentColor" />
    </svg>
)

const SmallCloseIcon = () => (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.25143 0.2515C0.586165 -0.0832353 1.12888 -0.0832351 1.46361 0.2515L8.73671 7.5246C9.07145 7.85933 9.07145 8.40205 8.73671 8.73678C8.40198 9.07152 7.85926 9.07152 7.52453 8.73678L0.25143 1.46368C-0.0833055 1.12895 -0.0833053 0.586235 0.25143 0.2515Z" fill="currentColor"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M0.251429 8.73678C-0.0833056 8.40205 -0.0833058 7.85933 0.251429 7.5246L7.52453 0.2515C7.85926 -0.0832353 8.40198 -0.083235 8.73671 0.2515C9.07145 0.586235 9.07145 1.12895 8.73671 1.46368L1.46361 8.73678C1.12888 9.07152 0.586165 9.07152 0.251429 8.73678Z" fill="currentColor"/>
    </svg>
)

const KebabIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5 6C13.5 6.82845 12.8285 7.5001 12.0001 7.5001C11.1718 7.5001 10.5002 6.82845 10.5002 6C10.5002 5.17159 11.1718 4.5 12.0001 4.5C12.8285 4.5 13.5 5.17159 13.5 6Z" fill="currentColor"/>
        <path d="M13.4998 12.0012C13.4998 12.8297 12.8282 13.5013 11.9999 13.5013C11.1715 13.5013 10.5 12.8297 10.5 12.0012C10.5 11.1728 11.1715 10.5012 11.9999 10.5012C12.8282 10.5012 13.4998 11.1728 13.4998 12.0012Z" fill="currentColor"/>
        <path d="M13.4998 18C13.4998 18.8284 12.8282 19.5 11.9999 19.5C11.1715 19.5 10.5 18.8284 10.5 18C10.5 17.1715 11.1715 16.4999 11.9999 16.4999C12.8282 16.4999 13.4998 17.1715 13.4998 18Z" fill="currentColor"/>
    </svg>
)

const ChainIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.6 12H15.4M9.45 8.5H6.9C5.99826 8.5 5.13346 8.86875 4.49584 9.52513C3.85821 10.1815 3.5 11.0717 3.5 12C3.5 12.9283 3.85821 13.8185 4.49584 14.4749C5.13346 15.1313 5.99826 15.5 6.9 15.5H9.45M14.55 8.5H17.1C18.0017 8.5 18.8665 8.86875 19.5042 9.52513C20.1418 10.1815 20.5 11.0717 20.5 12C20.5 12.9283 20.1418 13.8185 19.5042 14.4749C18.8665 15.1313 18.0017 15.5 17.1 15.5H14.55" stroke="#64617E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export interface CommentLink {
    url: string
    title?: string
}

export interface CommentMention {
    id: string | number
    name: string
}

interface CommentInputProps {
    projectId?: number | string
    parentCommentId?: number
    placeholder?: string
    initialValue?: string
    initialLinks?: CommentLink[]
    initialMentions?: CommentMention[]
    autoExpand?: boolean
    submitLabel?: 'send' | 'save'
    existingAttachments?: React.ReactNode
    existingAttachmentsCount?: number
    hasExistingAttachmentChanges?: boolean
    /** if set, open the link-edit form for this index right after mount */
    autoEditLinkIdx?: number | null
    onSubmit: (payload: { text: string; links: CommentLink[]; mentions: CommentMention[]; files: File[] }) => Promise<any> | void
    onCancel?: () => void
}

const getUserName = (user: any) =>
    `${user?.first_name || ''} ${user?.last_name || ''}`.trim()
    || user?.name
    || user?.email
    || 'Пользователь'

const normalizeUrl = (raw: string) => {
    const value = raw.trim()
    if (!value) return ''
    if (/^https?:\/\//i.test(value)) return value
    return `https://${value}`
}

export const parseUrl = (raw: string): URL | null => {
    try {
        return new URL(normalizeUrl(raw))
    } catch {
        return null
    }
}

type SimpleIcon = { title: string; slug: string; hex: string; path: string }

// hostname (without leading "www.") → { brand icon, human title }
const PROVIDERS: Record<string, { icon: SimpleIcon; name: string }> = {
    'youtube.com': { icon: siYoutube, name: 'YouTube — видео' },
    'youtu.be': { icon: siYoutube, name: 'YouTube — видео' },
    'figma.com': { icon: siFigma, name: 'Figma' },
    'notion.so': { icon: siNotion, name: 'Notion' },
    'github.com': { icon: siGithub, name: 'GitHub' },
    'docs.google.com': { icon: siGoogledocs, name: 'Google Документы' },
    'drive.google.com': { icon: siGoogledrive, name: 'Google Диск' },
    'sheets.google.com': { icon: siGooglesheets, name: 'Google Таблицы' },
    'slides.google.com': { icon: siGoogleslides, name: 'Google Презентации' },
    't.me': { icon: siTelegram, name: 'Telegram' },
    'loom.com': { icon: siLoom, name: 'Loom' },
    'miro.com': { icon: siMiro, name: 'Miro' },
    'vimeo.com': { icon: siVimeo, name: 'Vimeo' },
    'dropbox.com': { icon: siDropbox, name: 'Dropbox' },
    'atlassian.net': { icon: siConfluence, name: 'Confluence' },
    'confluence.com': { icon: siConfluence, name: 'Confluence' },
    'linear.app': { icon: siLinear, name: 'Linear' },
    'atlassian.com': { icon: siJira, name: 'Jira' },
    'trello.com': { icon: siTrello, name: 'Trello' },
}

const getProvider = (url: URL) => {
    const host = url.hostname.replace(/^www\./, '')
    if (PROVIDERS[host]) return PROVIDERS[host]
    // also match on the registrable-ish suffix (e.g. team.atlassian.net)
    const parts = host.split('.')
    for (let i = 1; i < parts.length - 1; i++) {
        const suffix = parts.slice(i).join('.')
        if (PROVIDERS[suffix]) return PROVIDERS[suffix]
    }
    return null
}

const BrandIcon = ({ icon }: { icon: SimpleIcon }) => (
    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label={icon.title}>
        <path d={icon.path} fill={`#${icon.hex}`} />
    </svg>
)

const deriveLinkTitle = (url: URL): string => {
    const provider = getProvider(url)
    if (provider) return provider.name
    // show the full url for plain links (matches the design)
    return url.href
}

export const getLinkIcon = (url: string): React.ReactNode => {
    const parsed = parseUrl(url)
    if (!parsed) return <ChainIcon />
    const provider = getProvider(parsed)
    if (provider) return <BrandIcon icon={provider.icon} />
    // unknown host — just the generic chain icon, no external favicon fetch
    return <ChainIcon />
}

const EditMenuIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.4695 19.9991H9.98339C9.53815 19.9991 9.17639 19.6373 9.17639 19.1921C9.17639 18.7468 9.53815 18.3851 9.98339 18.3851H20.4695C20.9147 18.3851 21.2765 18.7468 21.2765 19.1921C21.2765 19.6385 20.9147 19.9991 20.4695 19.9991Z" fill="currentColor"/>
        <path d="M18.2643 5.59826L17.1233 4.45734C16.5136 3.84755 15.4513 3.84755 14.8427 4.45734L13.1743 6.12577L16.5958 9.54733L18.2643 7.8789C18.5691 7.57401 18.7373 7.16991 18.7373 6.73798C18.7373 6.30847 18.5691 5.90315 18.2643 5.59826Z" fill="currentColor"/>
        <path d="M12.0346 7.26714L3.72143 15.5803C3.6682 15.6335 3.63069 15.7001 3.61375 15.7727L2.73416 19.5039C2.70271 19.6395 2.74263 19.7822 2.84184 19.8814C2.91807 19.9577 3.02091 20 3.12738 20C3.15762 20 3.18908 19.9964 3.21933 19.9891L6.95062 19.1095C7.02321 19.0926 7.09097 19.0551 7.14299 19.0018L15.4561 10.6887L12.0346 7.26714Z" fill="currentColor"/>
    </svg>
)
const TrashMenuIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.2 8.8C6.2 8.68954 6.28954 8.6 6.4 8.6H17.7111C17.8216 8.6 17.9111 8.68954 17.9111 8.8V19.65C17.9111 19.8754 17.8216 20.0916 17.6622 20.251C17.5027 20.4104 17.2865 20.5 17.0611 20.5H7.05C6.82457 20.5 6.60837 20.4104 6.44896 20.251C6.28955 20.0916 6.2 19.8754 6.2 19.65V8.8ZM8.75 6.05V4.35C8.75 4.12457 8.83955 3.90837 8.99896 3.74896C9.15837 3.58955 9.37457 3.5 9.6 3.5H14.5111C14.7365 3.5 14.9527 3.58955 15.1122 3.74896C15.2716 3.90837 15.3611 4.12457 15.3611 4.35V6.05H18.7611C19.2306 6.05 19.6111 6.43056 19.6111 6.9C19.6111 7.36944 19.2306 7.75 18.7611 7.75H5.35C4.88056 7.75 4.5 7.36944 4.5 6.9C4.5 6.43056 4.88056 6.05 5.35 6.05H8.75ZM10.65 5.2C10.5395 5.2 10.45 5.28954 10.45 5.4V5.85C10.45 5.96046 10.5395 6.05 10.65 6.05H13.4611C13.5716 6.05 13.6611 5.96046 13.6611 5.85V5.4C13.6611 5.28954 13.5716 5.2 13.4611 5.2H10.65ZM10.3556 12C9.88611 12 9.50556 12.3806 9.50556 12.85V16.25C9.50556 16.7194 9.88611 17.1 10.3556 17.1C10.825 17.1 11.2056 16.7194 11.2056 16.25V12.85C11.2056 12.3806 10.825 12 10.3556 12ZM13.7556 12C13.2861 12 12.9056 12.3806 12.9056 12.85V16.25C12.9056 16.7194 13.2861 17.1 13.7556 17.1C14.225 17.1 14.6056 16.7194 14.6056 16.25V12.85C14.6056 12.3806 14.225 12 13.7556 12Z" fill="#F04438"/>
    </svg>
)

// kebab menu on a chip — opens upward, "Редактировать" / "Удалить" like the project dropdowns
export function ChipMenu({ onEdit, onRemove }: { onEdit?: () => void; onRemove: () => void }) {
    const [open, setOpen] = useState(false)
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!open) return
        const handler = (e: MouseEvent) => {
            if (!(e.target instanceof Node)) return
            if (ref.current?.contains(e.target)) return
            setOpen(false)
        }
        document.addEventListener('mousedown', handler, true)
        return () => document.removeEventListener('mousedown', handler, true)
    }, [open])

    return (
        <div className={styles.commentInput__chipMenu} ref={ref}>
            <button
                type="button"
                className={styles.commentInput__chipKebab}
                onClick={() => setOpen((v) => !v)}
            >
                <KebabIcon />
            </button>
            {open && (
                <div className={styles.commentInput__chipMenuPopup}>
                    {onEdit && (
                        <button
                            type="button"
                            className={styles.commentInput__chipMenuItem}
                            onClick={() => { setOpen(false); onEdit() }}
                        >
                            <EditMenuIcon />
                            <span>Редактировать</span>
                        </button>
                    )}
                    <button
                        type="button"
                        className={`${styles.commentInput__chipMenuItem} ${styles.commentInput__chipMenuItemDanger}`}
                        onClick={() => { setOpen(false); onRemove() }}
                    >
                        <TrashMenuIcon />
                        <span>Удалить</span>
                    </button>
                </div>
            )}
        </div>
    )
}

export default function CommentInput({
    projectId,
    parentCommentId,
    placeholder = 'Напишите комментарий',
    initialValue = '',
    initialLinks,
    initialMentions,
    autoExpand = false,
    submitLabel = 'send',
    existingAttachments,
    existingAttachmentsCount = 0,
    hasExistingAttachmentChanges = false,
    autoEditLinkIdx = null,
    onSubmit,
    onCancel,
}: CommentInputProps) {
    const [expanded, setExpanded] = useState(autoExpand)
    const [text, setText] = useState(initialValue)
    const [links, setLinks] = useState<CommentLink[]>(initialLinks || [])
    const [mentions, setMentions] = useState<CommentMention[]>(initialMentions || [])
    const [files, setFiles] = useState<File[]>([])
    const [filePreviews, setFilePreviews] = useState<string[]>([])
    const [submitting, setSubmitting] = useState(false)
    const [submitError, setSubmitError] = useState<string | null>(null)
    const [isDragging, setIsDragging] = useState(false)

    const [showLinkForm, setShowLinkForm] = useState(false)
    const [linkUrl, setLinkUrl] = useState('')
    const [editingLinkIdx, setEditingLinkIdx] = useState<number | null>(null)

    const [mentionOpen, setMentionOpen] = useState(false)
    const [mentionSearch, setMentionSearch] = useState('')
    const [users, setUsers] = useState<any[]>([])
    const [usersLoaded, setUsersLoaded] = useState(false)
    const mentionSearchTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

    // inline "@" autocomplete typed directly in the textarea.
    // `inlineMention.at` is the index of the triggering "@" in `text`.
    const [inlineMention, setInlineMention] = useState<{ at: number; query: string } | null>(null)
    const inlineMentionTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

    const textareaRef = useRef<HTMLTextAreaElement>(null)
    const mentionSearchRef = useRef<HTMLInputElement>(null)
    const linkInputRef = useRef<HTMLInputElement>(null)
    const containerRef = useRef<HTMLDivElement>(null)
    const fileInputRef = useRef<HTMLInputElement>(null)
    const statusId = useId()

    const hasContent = useMemo(
        () => text.trim().length > 0 || links.length > 0 || mentions.length > 0 || files.length > 0 || existingAttachmentsCount > 0 || hasExistingAttachmentChanges,
        [text, links, mentions, files, existingAttachmentsCount, hasExistingAttachmentChanges]
    )
    const contentLength = useMemo(
        () => getCommentCharacterCount(serializeCommentContent(text, links, mentions, parentCommentId)),
        [text, links, mentions, parentCommentId],
    )
    const isOverLimit = contentLength > COMMENT_MAX_LENGTH
    const isNearLimit = contentLength >= COMMENT_LENGTH_WARNING

    useEffect(() => {
        setSubmitError(null)
    }, [text, links, mentions, files])

    const reportError = useCallback((message: string) => {
        setSubmitError(message)
        dispatchProjectNotification({ text: message, type: 'error' })
    }, [])

    const addFiles = useCallback((incoming: FileList | File[] | null) => {
        if (!incoming) return
        const list = Array.from(incoming)
        if (list.length === 0) return
        const validationError = getAttachmentValidationMessage(list, existingAttachmentsCount + files.length)
        if (validationError) {
            reportError(validationError)
            return
        }
        setFiles((prev) => [...prev, ...list])
    }, [existingAttachmentsCount, files.length, reportError])

    // Pasted/dropped files may point to a temp file the source app removes
    // before Send — copy them into memory while they are still readable.
    const addSnapshotFiles = (incoming: File[]) => {
        if (incoming.length === 0) return
        snapshotFiles(incoming)
            .then(addFiles)
            .catch((error) => {
                reportError('Не вдалося прочитати вставлений файл. Спробуйте ще раз.')
                console.error('Failed to read pasted file:', error)
            })
    }

    useEffect(() => {
        const urls = files.map((file) => file.type.startsWith('image/') ? URL.createObjectURL(file) : '')
        setFilePreviews(urls)
        return () => urls.forEach((url) => {
            if (url) URL.revokeObjectURL(url)
        })
    }, [files])

    const removeFile = (idx: number) => {
        setFiles((prev) => prev.filter((_, i) => i !== idx))
    }

    const attachDisabled = existingAttachmentsCount + files.length >= MAX_TASK_ATTACHMENTS

    const autoSize = useCallback(() => {
        const node = textareaRef.current
        if (!node) return
        node.style.height = 'auto'
        node.style.height = `${node.scrollHeight}px`
    }, [])

    useEffect(() => {
        if (expanded) {
            autoSize()
        }
    }, [expanded, text, autoSize])

    // close expanded view on outside click when empty
    useEffect(() => {
        if (!expanded) return

        const handleOutside = (event: MouseEvent) => {
            if (!(event.target instanceof Node)) return
            if (containerRef.current?.contains(event.target)) return
            if (mentionOpen) setMentionOpen(false)
            if (inlineMention) setInlineMention(null)
            if (showLinkForm) closeLinkForm()
            if (onCancel) {
                onCancel()
                return
            }
            if (!hasContent && !autoExpand) {
                setExpanded(false)
            }
        }

        document.addEventListener('mousedown', handleOutside, true)
        return () => document.removeEventListener('mousedown', handleOutside, true)
    }, [expanded, hasContent, showLinkForm, mentionOpen, inlineMention, autoExpand, onCancel])

    const fetchUsers = useCallback(async (search = '') => {
        try {
            const list = await UserService.getUsers({
                skip: 0,
                limit: 1000,
                ...(search ? { search } : {}),
                ...(projectId ? { project_id: Number(projectId) } : {}),
            })
            setUsers(Array.isArray(list) ? list : [])
        } catch (e) {
            console.error('Failed to fetch users for mention:', e)
            setUsers([])
        }
    }, [projectId])

    const openMentions = () => {
        closeLinkForm()
        setMentionSearch('')
        setMentionOpen(true)
        if (!usersLoaded) {
            setUsersLoaded(true)
            void fetchUsers()
        }
        setTimeout(() => mentionSearchRef.current?.focus(), 0)
    }

    const openLinkForm = (idx: number | null = null) => {
        setMentionOpen(false)
        setShowLinkForm(true)
        setEditingLinkIdx(idx)
        setLinkUrl(idx !== null ? (links[idx]?.url || '') : '')
        setTimeout(() => {
            const node = linkInputRef.current
            if (!node) return
            node.focus()
            if (idx !== null) {
                // when editing — select the whole url and show its beginning
                node.select()
                node.scrollLeft = 0
            }
        }, 0)
    }

    const closeLinkForm = () => {
        setShowLinkForm(false)
        setLinkUrl('')
        setEditingLinkIdx(null)
    }

    // when asked to edit a specific link right away (e.g. from a sent comment)
    useEffect(() => {
        if (autoEditLinkIdx === null || autoEditLinkIdx === undefined) return
        if (autoEditLinkIdx < 0 || autoEditLinkIdx >= (initialLinks?.length || 0)) return
        openLinkForm(autoEditLinkIdx)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleMentionSearchChange = (value: string) => {
        setMentionSearch(value)
        if (mentionSearchTimer.current) {
            clearTimeout(mentionSearchTimer.current)
        }
        mentionSearchTimer.current = setTimeout(() => fetchUsers(value), 300)
    }

    useEffect(() => () => {
        if (mentionSearchTimer.current) {
            clearTimeout(mentionSearchTimer.current)
        }
        if (inlineMentionTimer.current) {
            clearTimeout(inlineMentionTimer.current)
        }
    }, [])

    const addMention = (user: any) => {
        const id = user?.id
        if (id === undefined || id === null) return
        setMentions((prev) => prev.some((m) => String(m.id) === String(id))
            ? prev
            : [...prev, { id, name: getUserName(user) }])

        // if the picker was opened by typing "@" inline, drop the "@query"
        // fragment from the text now that it became a chip.
        if (inlineMention) {
            const before = text.slice(0, inlineMention.at)
            const after = text.slice(inlineMention.at + 1 + inlineMention.query.length)
            setText(before + after)
            setInlineMention(null)
            setTimeout(() => {
                const node = textareaRef.current
                if (node) {
                    node.focus()
                    node.selectionStart = node.selectionEnd = before.length
                }
            }, 0)
            return
        }

        setMentionOpen(false)
        textareaRef.current?.focus()
    }

    // Inspect the text right before the caret: if the current "word" starts
    // with "@" (and there's no whitespace between it and the caret) treat it
    // as an inline mention query and open the same people picker.
    const detectInlineMention = (value: string, caret: number) => {
        const upToCaret = value.slice(0, caret)
        // "@" at start of input or preceded by whitespace, then non-space chars
        const match = upToCaret.match(/(?:^|\s)(@[^\s@]*)$/)
        if (!match) {
            if (inlineMention) setInlineMention(null)
            return
        }
        const token = match[1]                 // e.g. "@iva"
        const at = caret - token.length        // index of the "@"
        const query = token.slice(1)           // e.g. "iva"
        setInlineMention({ at, query })
        setMentionOpen(false)
        closeLinkForm()
        if (!usersLoaded) {
            setUsersLoaded(true)
        }
        if (inlineMentionTimer.current) clearTimeout(inlineMentionTimer.current)
        inlineMentionTimer.current = setTimeout(() => fetchUsers(query), 250)
    }

    const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value
        setText(value)
        detectInlineMention(value, e.target.selectionStart ?? value.length)
    }

    const removeMention = (id: string | number) => {
        setMentions((prev) => prev.filter((m) => String(m.id) !== String(id)))
    }

    const addLink = () => {
        const parsed = parseUrl(linkUrl)
        if (!parsed) return
        const entry = { url: parsed.href, title: deriveLinkTitle(parsed) }
        setLinks((prev) => {
            if (editingLinkIdx !== null) {
                return prev.map((item, i) => (i === editingLinkIdx ? entry : item))
            }
            return [...prev, entry]
        })
        closeLinkForm()
        textareaRef.current?.focus()
    }

    const removeLink = (idx: number) => {
        setLinks((prev) => prev.filter((_, i) => i !== idx))
    }

    const resetState = () => {
        setText('')
        setLinks([])
        setMentions([])
        setFiles([])
        setSubmitError(null)
        setMentionOpen(false)
        setInlineMention(null)
        closeLinkForm()
        if (!autoExpand) {
            setExpanded(false)
        }
    }

    const handleSubmit = async () => {
        if (!hasContent || submitting) return
        if (isOverLimit) {
            setSubmitError(`Коментар не може перевищувати ${COMMENT_MAX_LENGTH} символів.`)
            return
        }
        setSubmitting(true)
        try {
            await onSubmit({ text: text.trim(), links, mentions, files })
            resetState()
        } catch (e) {
            const message = isCommentTooLongError(e)
                ? `Коментар не може перевищувати ${COMMENT_MAX_LENGTH} символів.`
                : getAttachmentUploadErrorMessage(e, undefined, 'Не вдалося надіслати коментар. Спробуйте ще раз.')
            reportError(message)
            console.error('Failed to submit comment:', e)
        } finally {
            setSubmitting(false)
        }
    }

    const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
        const items = e.clipboardData?.items
        const pastedText = e.clipboardData?.getData('text/plain').replace(/\r\n?/g, '\n') || ''
        const pastedHtml = e.clipboardData?.getData('text/html') || ''
        // Rich text keeps its formatting as comment markdown (lists, quotes,
        // tables, code); a bare spreadsheet selection still becomes a table.
        const insertedText = htmlToCommentMarkdown(pastedHtml)
            || clipboardTableToMarkdown(pastedHtml, pastedText)
            || pastedText
        const pasted: File[] = []
        if (items) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                if (item.kind === 'file' && item.type.startsWith('image/')) {
                    const file = item.getAsFile()
                    if (file) pasted.push(file)
                }
            }
        }

        if (insertedText) {
            e.preventDefault()
            const node = e.currentTarget
            const start = node.selectionStart ?? text.length
            const end = node.selectionEnd ?? start
            const nextText = `${text.slice(0, start)}${insertedText}${text.slice(end)}`
            const nextCaret = start + insertedText.length

            setText(nextText)
            detectInlineMention(nextText, nextCaret)
            setTimeout(() => {
                const currentNode = textareaRef.current
                if (!currentNode) return
                currentNode.selectionStart = currentNode.selectionEnd = nextCaret
                currentNode.scrollTop = currentNode.scrollHeight
            }, 0)
        }

        if (pasted.length > 0) {
            if (!insertedText) e.preventDefault()
            addSnapshotFiles(pasted)
        }
    }

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault()
        setIsDragging(false)
        addSnapshotFiles(Array.from(e.dataTransfer?.files || []))
    }

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        if (e.dataTransfer?.types?.includes('Files')) {
            e.preventDefault()
            setIsDragging(true)
        }
    }

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        if (e.currentTarget === e.target) setIsDragging(false)
    }

    const handleCancel = () => {
        resetState()
        onCancel?.()
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        // while the inline "@" picker is open, Enter picks the first match
        // (or just closes the picker) instead of submitting the comment.
        if (inlineMention) {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault()
                if (users.length > 0) {
                    addMention(users[0])
                } else {
                    setInlineMention(null)
                }
                return
            }
            if (event.key === 'Escape') {
                event.preventDefault()
                setInlineMention(null)
                return
            }
        }

        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            void handleSubmit()
        }
        if (event.key === 'Escape') {
            if (mentionOpen) { setMentionOpen(false); return }
            if (showLinkForm) { closeLinkForm(); return }
            handleCancel()
        }
    }

    if (!expanded) {
        const expand = () => {
            setExpanded(true)
            setTimeout(() => textareaRef.current?.focus(), 0)
        }
        return (
            <div className={styles.commentInput}>
                <div className={styles.commentInput__collapsed}>
                    <input
                        type="text"
                        placeholder={placeholder}
                        value=""
                        readOnly
                        onFocus={expand}
                        onClick={expand}
                    />
                    <div className={styles.commentInput__collapsed_send} onClick={expand}>
                        <SendIcon />
                    </div>
                </div>
            </div>
        )
    }

    const canSubmit = hasContent && !submitting && !isOverLimit

    return (
        <div
            className={styles.commentInput}
            ref={containerRef}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <input
                ref={fileInputRef}
                type="file"
                multiple
                hidden
                onChange={(e) => {
                    addFiles(e.target.files)
                    if (e.target) e.target.value = ''
                }}
            />
            <div
                className={`${styles.commentInput__box} ${isDragging ? styles.commentInput__box_dragging : ''}`}
            >
                <textarea
                    ref={textareaRef}
                    className={styles.commentInput__textarea}
                    placeholder={placeholder}
                    value={text}
                    rows={1}
                    aria-invalid={isOverLimit || Boolean(submitError)}
                    aria-describedby={statusId}
                    onChange={handleTextChange}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    onClick={(e) => detectInlineMention(text, e.currentTarget.selectionStart ?? text.length)}
                    onKeyUp={(e) => {
                        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(e.key)) {
                            detectInlineMention(text, e.currentTarget.selectionStart ?? text.length)
                        }
                    }}
                />

                {inlineMention && (
                    <div className={`${styles.commentInput__popup} ${styles.commentInput__popup_inline}`}>
                        <div className={styles.commentInput__popup_list}>
                            <div className={styles.commentInput__popup_listScroll}>
                                {users.length === 0 ? (
                                    <div className={styles.commentInput__popup_empty}>Участники не найдены</div>
                                ) : (
                                    users.map((u: any) => (
                                        <div
                                            key={u.id}
                                            className={styles.commentInput__popup_item}
                                            onMouseDown={(e) => { e.preventDefault(); addMention(u) }}
                                        >
                                            <div className={styles.commentInput__popup_avatar}>
                                                <Avatar user={u} />
                                            </div>
                                            <span>{getUserName(u)}</span>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {existingAttachments}

                {filePreviews.length > 0 && (
                    <div className={styles.commentInput__previews}>
                        {filePreviews.map((url, idx) => (
                            <div className={styles.commentInput__preview} key={`file-${idx}`}>
                                {files[idx]?.type.startsWith('image/') ? (
                                    <img src={url} alt={files[idx]?.name || ''} />
                                ) : (
                                    <span className={styles.commentInput__previewFileName}>
                                        {files[idx]?.name || 'Файл'}
                                    </span>
                                )}
                                <button
                                    type="button"
                                    className={styles.commentInput__previewRemove}
                                    onClick={() => removeFile(idx)}
                                    title="Удалить"
                                >
                                    <SmallCloseIcon />
                                </button>
                            </div>
                        ))}
                    </div>
                )}

                {(links.length > 0 || mentions.length > 0) && (
                    <div className={styles.commentInput__chips}>
                        {links.map((link, idx) => (
                            <div className={styles.commentInput__chip} key={`link-${link.url}-${idx}`}>
                                <span className={styles.commentInput__chip_icon}>{getLinkIcon(link.url)}</span>
                                <a href={link.url} target="_blank" rel="noopener noreferrer" className={styles.commentInput__chip_text}>
                                    {link.title || link.url}
                                </a>
                                <ChipMenu onEdit={() => openLinkForm(idx)} onRemove={() => removeLink(idx)} />
                            </div>
                        ))}
                        {mentions.map((mention) => (
                            <div className={styles.commentInput__mentionChip} key={`mention-${mention.id}`}>
                                <span className={styles.commentInput__mentionChip_label}>
                                    <span className={styles.commentInput__mentionChip_at}>@</span>
                                    <span className={styles.commentInput__mentionChip_name}>{mention.name}</span>
                                </span>
                                <button
                                    type="button"
                                    className={styles.commentInput__mentionChip_remove}
                                    onClick={() => removeMention(mention.id)}
                                >
                                    <SmallCloseIcon />
                                </button>
                            </div>
                        ))}
                    </div>
                )}

                <div className={styles.commentInput__status} id={statusId} aria-live="polite">
                    <span className={styles.commentInput__error} role={submitError || isOverLimit ? 'alert' : undefined}>
                        {submitError || (isOverLimit ? `Коментар не може перевищувати ${COMMENT_MAX_LENGTH} символів.` : '')}
                    </span>
                    <span className={`${styles.commentInput__counter} ${isNearLimit ? styles.commentInput__counter_warning : ''} ${isOverLimit ? styles.commentInput__counter_error : ''}`}>
                        {contentLength} / {COMMENT_MAX_LENGTH}
                    </span>
                </div>

                <div className={styles.commentInput__toolbarWrap}>
                    {showLinkForm && (
                        <div className={styles.commentInput__linkForm}>
                            <div className={styles.commentInput__linkForm_label}>
                                {editingLinkIdx !== null ? 'Изменить ссылку' : 'Вставить ссылку'}
                            </div>
                            <div className={`${styles.commentInput__linkForm_field} ${linkUrl ? styles.commentInput__linkForm_fieldFocused : ''}`}>
                                <input
                                    ref={linkInputRef}
                                    type="text"
                                    placeholder=""
                                    value={linkUrl}
                                    onChange={(e) => setLinkUrl(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { e.preventDefault(); addLink() }
                                        if (e.key === 'Escape') closeLinkForm()
                                    }}
                                />
                                {linkUrl && (
                                    <button
                                        type="button"
                                        className={styles.commentInput__linkForm_clear}
                                        onClick={() => { setLinkUrl(''); linkInputRef.current?.focus() }}
                                    >
                                        <SmallCloseIcon />
                                    </button>
                                )}
                            </div>
                            <div className={styles.commentInput__linkForm_actions}>
                                <button
                                    type="button"
                                    className={`${styles.commentInput__linkForm_btn} ${styles.commentInput__linkForm_btnCancel}`}
                                    onClick={closeLinkForm}
                                >
                                    Отменить
                                </button>
                                <button
                                    type="button"
                                    className={`${styles.commentInput__linkForm_btn} ${styles.commentInput__linkForm_btnOk}`}
                                    disabled={!parseUrl(linkUrl)}
                                    onClick={addLink}
                                >
                                    {editingLinkIdx !== null ? 'Сохранить' : 'Вставить'}
                                </button>
                            </div>
                        </div>
                    )}

                    <div className={styles.commentInput__toolbar}>
                        <button
                            type="button"
                            className={styles.commentInput__tool}
                            title={attachDisabled ? `Максимум ${MAX_TASK_ATTACHMENTS} файлов` : 'Прикрепить файл'}
                            disabled={attachDisabled}
                            onClick={() => fileInputRef.current?.click()}
                        >
                            <AttachToolIcon />
                        </button>

                        <div className={styles.commentInput__mentionAnchor}>
                            <button
                                type="button"
                                className={styles.commentInput__tool}
                                title="Упомянуть участника"
                                onClick={() => (mentionOpen ? setMentionOpen(false) : openMentions())}
                            >
                                <MentionToolIcon />
                            </button>
                            {mentionOpen && (
                                <div className={styles.commentInput__popup}>
                                    <div className={`${styles.commentInput__popup_search} ${mentionSearch ? styles.commentInput__popup_searchFocused : ''}`}>
                                        <SearchPopupIcon />
                                        <input
                                            ref={mentionSearchRef}
                                            type="text"
                                            value={mentionSearch}
                                            placeholder="Поиск участников..."
                                            onChange={(e) => handleMentionSearchChange(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Escape') setMentionOpen(false)
                                            }}
                                        />
                                    </div>
                                    <div className={styles.commentInput__popup_list}>
                                        <div className={styles.commentInput__popup_listScroll}>
                                            {users.length === 0 ? (
                                                <div className={styles.commentInput__popup_empty}>Участники не найдены</div>
                                            ) : (
                                                users.map((user: any) => (
                                                    <div
                                                        key={user.id}
                                                        className={styles.commentInput__popup_item}
                                                        onClick={() => addMention(user)}
                                                    >
                                                        <div className={styles.commentInput__popup_avatar}>
                                                            <Avatar user={user} />
                                                        </div>
                                                        <span>{getUserName(user)}</span>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <button
                            type="button"
                            className={styles.commentInput__tool}
                            title="Вставить ссылку"
                            onClick={() => (showLinkForm ? closeLinkForm() : openLinkForm())}
                        >
                            <LinkToolIcon />
                        </button>

                        {submitLabel === 'save' ? (
                            <div className={styles.commentInput__editActions}>
                                {onCancel && (
                                    <button
                                        type="button"
                                        className={styles.commentInput__cancel}
                                        aria-label="Отмена"
                                        title="Отмена"
                                        onClick={handleCancel}
                                    >
                                        Отмена
                                    </button>
                                )}
                                <button
                                    type="button"
                                    className={styles.commentInput__save}
                                    disabled={!canSubmit}
                                    onClick={handleSubmit}
                                    aria-label="Сохранить комментарий"
                                    title={isOverLimit ? `Максимум ${COMMENT_MAX_LENGTH} символів` : 'Сохранить'}
                                >
                                    Сохранить
                                </button>
                            </div>
                        ) : (
                            <button
                                type="button"
                                className={`${styles.commentInput__send} ${canSubmit ? styles.commentInput__send_active : ''}`}
                                disabled={!canSubmit}
                                onClick={handleSubmit}
                                aria-label="Надіслати коментар"
                                title={isOverLimit ? `Максимум ${COMMENT_MAX_LENGTH} символів` : undefined}
                            >
                                <SendIcon />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
